import * as Yup from 'yup';

export function contactSchema() {
  return Yup.object().shape({
    firstName: Yup.string().required('Required Field'),
    lastName: Yup.string().required('Required Field'),
    relationship: Yup.string(),
    phoneNumber: Yup.string()
      .required('Required Field')
      .test('valid-phone-number', 'Phone number is not valid', (phoneNumber) =>
        phoneNumber ? /^[0-9]{10}$/.test(phoneNumber) : true
      )
      .test(
        'start-with-zero',
        'Phone number can not begin with 0',
        (phoneNumber) => !(phoneNumber && phoneNumber[0] === '0')
      ),
    email: Yup.string().email(),
  });
}
